export const FullStar = {
    // Header
    title:"Full Star",
    subtitle:"Godot | 2D",
    genre:"Arcade | Movement",

    //Hero
    poster:"/Thumbnails/Full Star_Logo.png",
    releaseDate:"Oct 2024",
    studioName:"",
    teamSize:"6",
    platforms:"PC",
    responsiblities:"",
    engine:"Godot, GDScript",
    projectLength:"2 Weeks",

    //Description
    desc:[`Full Star is a physics based top down game created in Godot with the objective to collect all of the star pieces in order to become a "Full Star".\n\nAll while fighting the gravity of planets and other objects`,

        `Follow the constellation and avoid being sucked into any planets to complete your star!`
    ],
    img:["/Games/Full Star/Full Star_Logo.png", "/Games/Full Star/Full Star_Gameplay.png"
    ],


    //Home Screen Hero
    thumbnail:"/Thumbnails/Full Star_Logo.png",
    shortDesc:`2D Physics Movement game built in Godot, made as part of a 2 week long "Game Jam".\n\nCollect the missing pieces of your Star while avoiding obstacles and navigating gravity!`,
    badge:"./Project Badges/godot-gdscript.svg",
    url:"/projects/Full Star",
    type:"Games",

    //Special Sections
    downloadable:"yes",
    credits:"",
    awards:"",
    awardImg:[

    ],

    //Links
    githubURL:"https://github.com/DrakeMitchell/FullStar-325-FA24-Public",
    itchioURL:"https://severedx.itch.io/full-star",
    itchioEmbedURL:"https://itch.io/embed/3032970?linkback=true&amp;link_color=d48922",
    steamURL:"",


}